import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import type { ReadOnlyManufacturerCardProps } from '../../types/ReadOnlyManufacturerCardProps';

const ReadOnlyManufacturerCard: React.FC<
  ReadOnlyManufacturerCardProps
> = ({ id, description }) => {
  return (
    <Box sx={{ marginTop: '12px' }}>
      <Typography
        variant="body2"
        data-testid={id}
      >
        {description}
      </Typography>
    </Box>
  );
};

export default ReadOnlyManufacturerCard;
